import { useEffect, useMemo, useState } from 'react'
import { texts } from '../contents'

export const useText = (
  active: string,
  AAbonus: string,
  ante: string,
  aaWin: string,
  showAAWin: boolean,
  gameState: number,
  winType: number,
  currency: string,
  winAmount: string,
  isFolded: boolean,
  precision: number,
) => {
  const [emptyAnte, setEmptyAnte] = useState<boolean>(true)
  const [emptyAA, setEmptyAA] = useState<boolean>(true)

  useEffect(() => {
    ante !== '0' ? setEmptyAnte(false) : setEmptyAnte(true)
    AAbonus !== 'AA' ? setEmptyAA(false) : setEmptyAA(true)
  }, [ante, AAbonus])

  const text = useMemo(() => {
    if (gameState === 0) {
      if (active === 'ante') {
        if (emptyAnte) {
          return texts.addChipsToAnte()
        }
        if (emptyAA) {
          return texts.aaBonusIsOptional()
        }
      }
      if (active === 'bonus') {
        if (emptyAA) {
          return texts.addChipsToAAbonus()
        }
        if (emptyAnte) {
          return texts.anteIsRequired()
        }
      }
      if (!emptyAA && !emptyAnte) {
        return texts.empty()
      }
    } else if (!isFolded) {
      return texts.resultText(
        aaWin,
        showAAWin,
        winType,
        precision,
        currency,
        winAmount,
        gameState,
      )
    }
  }, [gameState, active, emptyAnte, emptyAA, winType])

  return text
}
